import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const fromLoc = location.state?.from;
  const from = fromLoc ? `${fromLoc.pathname}${fromLoc.search || ""}` : "/configurateur";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenue ${u.contact_name}`);
      navigate(u.role === "admin" ? "/admin" : from, { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="login-page" className="flex justify-center px-6 pt-12 sm:pt-20 pb-16">
      <form onSubmit={submit} className="paper p-8 lg:p-10 w-full max-w-md space-y-5">
        <div>
          <p className="eyebrow mb-2">Espace professionnel</p>
          <h1 className="text-3xl">Connexion</h1>
        </div>
        <div>
          <Label>Email</Label>
          <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label>Mot de passe</Label>
            <Link
              to="/mot-de-passe-oublie"
              data-testid="link-forgot-password"
              className="text-xs text-primary hover:underline"
            >
              Mot de passe oublié ?
            </Link>
          </div>
          <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <Button data-testid="login-submit" type="submit" className="btn-primary w-full" disabled={loading}>
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Se connecter"}
        </Button>
        <p className="text-sm text-muted-foreground text-center">
          Pas encore de compte ?{" "}
          <Link to="/register" data-testid="link-register" className="text-primary font-medium hover:underline">
            Créer un compte pro
          </Link>
        </p>
      </form>
    </main>
  );
}
